export default __webpack_public_path__ + "static/benefits-efficiency-a2702d12b2764617fd9b348575f74185.mp4";